import React, { useState } from 'react';
import { ButtonGroup, Button } from 'reactstrap';
import PropTypes from 'prop-types';
import './styles.css';

const propTypes = {
    defaultState: PropTypes.oneOf(['false', 'neutral', 'true']),
    states: PropTypes.shape({
        falseState: {
            title: PropTypes.string.isRequired,
            onClick: PropTypes.func.isRequired,
        },
        neutralState: {
            title: PropTypes.string.isRequired,
            onClick: PropTypes.func.isRequired,
        },
        trueState: {
            title: PropTypes.string.isRequired,
            onClick: PropTypes.func.isRequired,
        },
    }),
};

const TripleStateSwitch = ({ defaultState, states }) => {
    const getDefaultState = (defaultState) => {
        switch (defaultState) {
            case 'false':
                return 0;
            case 'true':
                return 2;
            default:
                return 1;
        }
    };

    const [state, setState] = useState(getDefaultState(defaultState));

    const toggleState = (nextState) => {
        setState(nextState);
    };

    const onFalseClick = () => {
        toggleState(0);
        states?.falseState?.onClick();
    };

    const onNeutralClick = () => {
        toggleState(1);
        states?.neutralState?.onClick();
    };

    const onTrueClick = () => {
        toggleState(2);
        states?.trueState?.onClick();
    };

    return (
        <div className="button-group-container">
            <ButtonGroup>
                <Button
                    outline
                    onClick={() => onFalseClick()}
                    className={`rounded-button rounded-button-false ${
                        state === 0 ? 'active-false' : ''
                    }`}>
                    {states?.falseState?.title}
                </Button>
                <Button
                    outline
                    onClick={() => onNeutralClick()}
                    className={`rounded-button rounded-button-neutral ${
                        state === 1 ? 'active-neutral' : ''
                    }`}>
                    {states?.neutralState?.title}
                </Button>
                <Button
                    outline
                    onClick={() => onTrueClick()}
                    className={`rounded-button rounded-button-true ${
                        state === 2 ? 'active-true' : ''
                    }`}>
                    {states?.trueState?.title}
                </Button>
            </ButtonGroup>
        </div>
    );
};
TripleStateSwitch.propTypes = propTypes;
export default TripleStateSwitch;
